module.exports = __webpack_public_path__ + "img/logoIconBlue.0ac9f50b.svg";